import type { LoaderFunction, RouteObject } from 'react-router'
import { isRefreshDesign } from '@/infra/design'
import type { NotificationsFeature } from '@/features/notifications'
import { createNotificationsViewLoader } from './notification-route-loaders'

/**
 * Options for {@link createRoutes}.
 */
export interface CreateNotificationsRoutesOptions {
  notifications: NotificationsFeature

  /**
   * Loads the job shown next to the notifications, owned by the jobs feature.
   */
  jobPaneLoader: LoaderFunction
}

/**
 * Creates routes for the notifications feature. The classic design shows
 * notifications in a sidebar instead of a page.
 */
export function createRoutes(
  options: CreateNotificationsRoutesOptions,
): RouteObject[] {
  if (!isRefreshDesign) {
    return []
  }

  return [
    {
      path: '/notifications/:jobId?',
      loader: createNotificationsViewLoader(options),
      lazy: {
        Component: () =>
          import('@/features/notifications/components/NotificationsPage/NotificationsPageContainer').then(
            (r) => r.default,
          ),
      },
    },
  ]
}
